import Bugsnag from '@bugsnag/js';

/**
 * Bugsnag navigation tracker - logs route changes as breadcrumbs
 *
 * This afterEach hook creates breadcrumbs in Bugsnag for navigation tracking,
 * which helps debug issues by showing the user's navigation path
 */
export function bugsnagNavigationTracker(to) {
    Bugsnag.leaveBreadcrumb(`Route: ${to.fullPath}`, {
        type: 'navigation',
    });
}
